import React from 'react'

function ChallengeBadgePopup() {
  return (
    <div>
      xccxc
    </div>
  )
}

export default ChallengeBadgePopup
